import { render, staticRenderFns } from "./IFrameConfigurator.vue?vue&type=template&id=001c35ee&"
import script from "./IFrameConfigurator.vue?vue&type=script&lang=js&"
export * from "./IFrameConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports